export default __webpack_public_path__ + "static/dart-4713e941f7628e82cad011e10a3e00ed.svg";